import { useMediaQuery } from '@mui/material';
import { IBudgetItem } from '../../createAndEdit/types';
import { parseDiscountPercent } from '../../createAndEdit/utils/budgetCalculations';
import DetailServiceItemRow from './DetailServiceItemRow';
import DetailServiceItemsTableMobile from './mobile/DetailServiceItemsTableMobile';
import DetailServiceMinimizedtemRow from './DetailServiceIMinimizedtemRow';

interface DetailServiceIMinimizedtemsTableProps {
  items: IBudgetItem[];
  serviceSubtotal?: number;
}

const DetailServiceIMinimizedtemsTable = (props: DetailServiceIMinimizedtemsTableProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const parseQuantityToNumber = (qty: string | number | undefined): number => {
    if (qty === undefined || qty === null) return 0;
    const qtyStr = String(qty);
    const clean = qtyStr.replace(/[^\d.,]/g, '').replace(',', '.');
    return Number.parseFloat(clean) || 0;
  };

  const visibleItems = (props.items || []).filter((item) => {
    if (item.removed === true) return false;
    const quantity = parseQuantityToNumber(item.quantity);
    return quantity > 0;
  });

  const calculatedSubtotal = () => {
    return visibleItems.reduce((sum, item) => {
      if (item.isCovered === true) return sum;
      return sum + (parseQuantityToNumber(item.quantity) * item.value * (1 - parseDiscountPercent(item.discount) / 100));
    }, 0);
  };

  if (isMobile) {
    return (
      <DetailServiceItemsTableMobile
        items={props.items}
        serviceSubtotal={props.serviceSubtotal}
      />
    );
  }


  const classNames = {
    header: 'font-semibold text-size-12 text-gray-600',
    body: 'text-size-14 text-gray-500',
  };
  return (
    <div className="overflow-x-auto">
      <table
        className="table table-layout-fixed table-column-overflow-hidden table-head-filled mb-3 w-full [&_td]:border-0 [&_th]:border-0 [&_tbody_tr]:border-0 [&_tbody_tr]:border-b-0 [&_thead_tr]:border-0 [&_thead_tr]:border-b-0 [&_tbody_tr_td]:border-0 [&_tbody_tr_td]:border-b-0 [&_thead_tr_th]:border-0 [&_thead_tr_th]:border-b-0"
        style={{ borderCollapse: 'separate', borderSpacing: 0 }}
      >
      <thead>
        <tr className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
          <th className="w-[5%] border-0 !border-b-0 " style={{ borderBottom: 'none' }}>
            <span className={classNames.header}>Ref.</span>
          </th>
          <th className="w-[23.75%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            <span className={classNames.header}>Descrição</span>
          </th>
          <th className="w-[23.75%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            <span className={classNames.header}>Quantidade</span>
          </th>
          <th className="w-[23.75%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            <span className={classNames.header}>% Desconto</span>
          </th>
          <th className="w-[23.75%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            <span className={classNames.header}>Subtotal (R$)</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {visibleItems.map((item, index) => (
          <DetailServiceMinimizedtemRow 
            key={`item-${item.ref}-${index}`} 
            item={item}
          />
        ))}
      </tbody>
      {typeof props.serviceSubtotal === 'number' && (
        <tfoot className=''>
          <tr className="w-full border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            <td className=" text-right" colSpan={8} style={{ borderTop: '1px solid #e9e9e9' }}>
              <span className="text-gray-600 mr-2 text-size-16 ">Subtotal do serviço:</span>
              <span className="text-gray-600 pr-2 text-size-16">{formatCurrency(calculatedSubtotal())}</span>
            </td>
          </tr>
        </tfoot>
      )}
    </table>
    </div>
  );
};

export default DetailServiceIMinimizedtemsTable;
